import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-develop',
	templateUrl: './cig-develop.component.html',
	styleUrls: ['./cig-develop.component.scss']
})
export class CigDevelopComponent implements OnInit {

	@Input() foursightassets;
	@Input() author;
	@Input() slides;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
